// extracted by mini-css-extract-plugin
export default {"outer_div":"InfoPage_outer_div__zjf9c","vid_demo":"InfoPage_vid_demo__DXYhV"};